<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="清单名称" prop="name">
            <el-input v-model.trim="searchForm.name" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" filterable multiple collapse-tags clearable @change="onSearch">
              <el-option v-for="item in ['未发布', '已发布', '延期未发布']" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <!-- 可能要改成时分秒 23:59:59-->
          <el-form-item label="预计发布时间" prop="publishDate">
            <el-date-picker v-model="searchForm.publishDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            <!-- <form-date-range :form="searchForm" startKey="expectedStartDate" endKey="expectedEndDate" :usingTime="false" valueFormat="yyyy-MM-dd">
            </form-date-range> -->
          </el-form-item>
          <el-form-item label="实际发布时间" prop="realPublishDate">
            <!-- <el-date-picker v-model="searchForm.realPublishDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker> -->
            <form-date-range :form="searchForm" startKey="realPublishDateStart" endKey="realPublishDateEnd" :usingTime="false" valueFormat="yyyy-MM-dd">
            </form-date-range>
          </el-form-item>
          <el-form-item label="基础信息负责人" prop="baseUser">
            <el-input v-model.trim="searchForm.baseUser" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品文案负责人" prop="productUser">
            <el-input v-model.trim="searchForm.productUser" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="商品价格负责人" prop="goodsUser">
            <el-input v-model.trim="searchForm.goodsUser" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SKU查询" prop="skuName">
            <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch" placeholder="支持编码名称查询" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="handleEdit(null)">新增</el-button>
        <el-button type="primary" size="mini" @click="exportExcelMerge">合并导出</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="name" label="清单名称" min-width="150"></el-table-column>
        <el-table-column prop="publishDate" label="预计发布时间" min-width="160"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100">
          <template slot-scope="{ row }">
            <span :class="row.status === '延期未发布' && 'red-text-btn'">{{ row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="realPublishDate" label="实际发布时间" min-width="160"></el-table-column>
        <el-table-column prop="spuQty" label="SPU数量" min-width="80"></el-table-column>
        <el-table-column prop="skuQty" label="商品数量" min-width="80"></el-table-column>
        <el-table-column prop="baseNoFinishQty" label="基础信息未完成" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" class="red-text-btn" @click="goDetails('InformationNotMaintained', row)" v-if="row.baseNoFinishQty">{{
              row.baseNoFinishQty
            }}</el-button>
            <span v-else>{{ row.baseNoFinishQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productNoFinishQty" label="产品文案未完成" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" class="red-text-btn" @click="goDetails('TextNotMaintained', row)" v-if="row.productNoFinishQty">{{
              row.productNoFinishQty
            }}</el-button>
            <span v-else>{{ row.productNoFinishQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="priceFinishQty" label="商品价格未完成" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" class="red-text-btn" @click="goDetails('PriceMotMaintained', row)" v-if="row.priceFinishQty">{{
              row.priceFinishQty
            }}</el-button>
            <span v-else>{{ row.priceFinishQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="baseUser" label="基础信息负责人" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productUser" label="产品文案负责人" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsUser" label="商品价格负责人" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="80"></el-table-column>
        <el-table-column prop="creationDate" label="创建时间" min-width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="210">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="handleRelease(row)"
              v-if="row.status !== '已发布' && row.baseNoFinishQty == 0 && row.productNoFinishQty == 0 && row.priceFinishQty == 0"
              >发布</el-button
            >
            <el-button type="text" @click="handleEdit(row)" v-if="row.status !== '已发布'">编辑</el-button>
            <el-button type="text" @click="handleView(row)">查看</el-button>
            <el-button type="text" class="red-text-btn" @click="handleDelete(row)" v-if="['未发布', '延期未发布'].includes(row.status)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import imgShow from '@/views/components/imgShow';
export default {
  // name: 'ListingList',
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      imgList: [],
      loading: false,
      statusOptions: [
        { label: '未发布', value: 'draft' },
        { label: '进行中', value: 'processing' },
        { label: '已完成', value: 'completed' },
        { label: '已取消', value: 'cancelled' },
      ],
      searchForm: {
        name: '',
        status: [],
        expectedStartDate: '',
        expectedEndDate: '',
        actualStartDate: '',
        actualEndDate: '',
        baseUser: '',
        productUser: '',
        goodsUser: '',
        skuName: '',
      },
      exportData: {},
    };
  },
  computed: {},
  mounted() {
    let query = this.$route.query;
    this.searchForm.name = query.name || '';
    this.searchForm.status = query.status || [];
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productListPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      (this.searchForm = {
        productCode: '',
        productName: '',
        fileName: '',
        uploadType: '',
        uploadSource: '',
        dts: '',
        dte: '',
        status: [],
      }),
        (this.tableData.pageNum = 1);
      this.onSearch();
    },

    handleEdit(row) {
      this.$router.push({
        path: '/newProduct/createList',
        query: row,
      });
    },

    handleView(row) {
      this.$router.push({
        path: '/newProduct/listing-list-details',
        query: { listNo: row.listNo },
      });
    },

    goDetails(tabName, row) {
      this.$router.push({
        path: '/newProduct/listing-list-details',
        query: { tabName, ...row },
      });
    },

    handleRelease(row) {
      this.$confirm('是否确认发布?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const formData = new FormData();
          formData.append('listNo', row.listNo);
          this.$q.newProduct.productListPublish({ data: formData }).then((res) => {
            if (res.success) {
              this.$message.success('发布成功');
              this.onSearch();
            }
          });
        })
        .catch(() => {});
    },
    handleDelete(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 调用删除接口
          const formData = new FormData();
          formData.append('listNo', row.listNo);
          this.$q.newProduct.productListDel({ data: formData }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功');
              this.onSearch();
            }
          });
        })
        .catch(() => {});
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'newProductListExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    exportExcelMerge() {
      const _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$q.newProduct.productListExport({ data: this.searchFormData.filterData }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                if (res.data.taskResult == '成功') {
                  _this.downloadRes(res.data.filePath, res.data.taskDesc);
                } else {
                  _this.$message.error(res.data.failReason);
                }
                clearInterval(timer);
                loading.close();
              }
            })
            .catch((err) => {
              loading.close();
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName + '' + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
</style>
